
import React, { Component } from 'react'
import { Stepper, GetInfo } from '@operations/shared';
import CreateUserCommentForm from './createUserCommentForm';
import { getUserByPhoneApi } from '../../utils/apisConsts';
class CreateUserComment extends Component{
    state = {
        componentSteps: [
            {
                title: 'Get User',
                content: <GetInfo apiLink={getUserByPhoneApi} />,
                id: 0,
            }, {
                title: 'Add User Comment',
                content: <CreateUserCommentForm />,
                id: 1
            },
        ]
    }

    render() {
        const { componentSteps } = this.state;
        return (
            <>
                <Stepper componentSteps={componentSteps} />
            </>
        )
    }
}

export default CreateUserComment
